import * as Yup from "yup";

const CreateSiteSchema = Yup.object().shape({
	route: Yup.string().required("A route is required."),
	siteName: Yup.string()
		.required("A site name is required.")
		.max(60, "You have reached the 60 character limit.")
		.matches(
			/^([a-zA-Z0-9^([a-zA-Z0-9\s\/\(\(\)\&'.-](?! \.)(?!\. )(?!\' )(?! \))(?!\s\s)(?![a-zA-Z0-9]\()(?!\( ))*[^\s\.'&%$£-]$/g,
			"Make sure your name conforms to the standard"
		)
		.matches(
			/^([^\s-])/g,
			"There should be no spaces or hypens before the name."
		)
		.matches(
			/^[A-Z]/g,
			"The first character of your site name needs to be a capital"
		),
	siteType: Yup.string().required("The site type is required."),
	operationalStatus: Yup.string().required(
		"An operational status is required."
	),
	altSiteName: Yup.string()
		.max(200, "You have reached the 200 character limit."),
	elr: Yup.string().max(50, "You have reached the 50 character limit."),
	siteMileage: Yup.string()
		.matches(/^(\d\d\d.\d\d\d\d)/g, "Please use the correct format - mmm.yyyy")
		.max(8, "You have reached the 8 character limit."),
	sitePostCode: Yup.string().max(
		15,
		"You have reached the 15 character limit."
	),
	comment: Yup.string().max(80, "You have reached the 80 character limit."),
});

export default CreateSiteSchema;

// \s\/\(\)&.-
